// extracted by mini-css-extract-plugin
export var activityContainer = "_hd-0";
export var typingIndicatorContainer = "_hd-1";
export var typingIndicatorDot = "_hd-2";
export var wave = "_hd-3";